import React, { useState } from 'react';
import styles from './EmailTypeRow.module.css';
import { Row, Col, Input, Icon, Checkbox, Tooltip } from 'antd';
import DragHandle from '../../../../components/miscellaneous/DragHandle';
import { useEditEmailTypesStore } from '../store';
import useDebounce from 'react-use/lib/useDebounce';

export default function EmailTypeRow({ emailType }) {
  const [type, setType] = useState(emailType.type),
    [publicName, setPublicName] = useState(emailType.publicName),
    [unsubscriptionCustomizable, setUnsubscriptionCustomizable] = useState(
      emailType.unsubscriptionCustomizable,
    );
  const { removeEmailType, editEmailType } = useEditEmailTypesStore();
  useDebounce(
    () => {
      editEmailType(emailType.id, {
        type,
        publicName,
        unsubscriptionCustomizable,
      });
    },
    200,
    [type, publicName, unsubscriptionCustomizable, emailType.id],
  );
  return (
    <div className={styles.wrapper}>
      <Row align="middle" justify="space-between" type="flex">
        <Col span={22}>
          <Row align="middle" gutter={8} justify="space-between" type="flex">
            <Col span={5}>
              <p style={{ marginBottom: 0, width: 100, fontSize: 10 }}>
                Internal Name
              </p>
              <Input
                placeholder="Internal Name"
                size="small"
                value={type}
                onChange={e => setType(e.target.value)}
              />
            </Col>
            <Col span={14}>
              <p style={{ marginBottom: 0, width: 100, fontSize: 10 }}>
                Public Name
              </p>
              <Input
                placeholder="Public Name"
                size="small"
                value={publicName}
                onChange={e => setPublicName(e.target.value)}
              />
            </Col>
            <Col span={5}>
              <Tooltip title="Show UI for user to customize unsubscription preferences">
                <Checkbox
                  checked={unsubscriptionCustomizable}
                  onChange={e =>
                    setUnsubscriptionCustomizable(e.target.checked)
                  }
                >
                  Show Preferences UI
                </Checkbox>
              </Tooltip>
            </Col>
          </Row>
        </Col>
        <Col span={2}>
          <div
            className="flex items-center space-x-2"
            style={{ justifyContent: 'flex-end' }}
          >
            {emailType.new && (
              <Icon
                style={{ fontSize: 16 }}
                theme="twoTone"
                twoToneColor="#ff3333"
                type="delete"
                onClick={e => {
                  e.stopPropagation();
                  removeEmailType(emailType.id);
                }}
              />
            )}
            <DragHandle />
          </div>
        </Col>
      </Row>
    </div>
  );
}
